import { ReturnedAction } from '../reduxTypes';

import { SummaryData, DateRange, MessagingInfo, MetaData } from '../../types';
import { Currency } from './../reduxTypes';

export const setOverviewData = (value: SummaryData): ReturnedAction => ({
  type: 'SET_OVERVIEW_DATA',
  value
});

export const setDateRangeLimit = (value: Array<DateRange>): ReturnedAction => ({
  type: 'SET_DATE_RANGE_LIMIT',
  value
});

export const setSelectedCurrency = (value: string): ReturnedAction => ({
  type: 'SET_SELECTED_CURRENCY',
  value
});

export const setDefaultCurrency = (value: string): ReturnedAction => ({
  type: 'SET_DEFAULT_CURRENCY',
  value
});

export const setGlanceMarkets = (value: string): ReturnedAction => ({
  type: 'SET_GLANCE_MARKETS',
  value
});

export const setGlanceDefaults = (value: string): ReturnedAction => ({
  type: 'SET_GLANCE_DEFAULTS',
  value
});

export const setCurrencies = (value: Array<Currency>): ReturnedAction => ({
  type: 'SET_CURRENCIES',
  value
});

export const setEnvironment = (value: string): ReturnedAction => ({
  type: 'SET_ENVIRONMENT',
  value
});

export const setMessagingInfo = (value: Array<MessagingInfo>): ReturnedAction => ({
  type: 'SET_MESSAGING',
  value
});

export const setMetaData = (value: MetaData): ReturnedAction => ({
  type: 'SET_META_DATA',
  value
});

export const setUnreadNotes = (value: number): ReturnedAction => ({
  type: 'SET_UNREAD_NOTES',
  value
});

export const setIntervalId = (value: any): ReturnedAction => ({
  type: 'SET_INTERVAL_ID',
  value
});
